// Locale/region configuration for rsa-agent — New Zealand build.
// Swap this file's values for another market instead of hardcoding currency in UI.
const localeConfig = {
  intlLocale: 'en-NZ',
  /** IANA timezone — overridden at runtime from Admin config. */
  timezone: 'Pacific/Auckland',
  currency: {
    code: 'NZD',
    symbol: '$',
  },
  /** ISO 3166-1 alpha-2 codes for Google Places `componentRestrictions` (max 5). */
  mapsCountryCodes: ['nz'],
  mapsRegionLabel: 'New Zealand',
};

export default localeConfig;
